var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeimLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.088,
    height: 33.864,
    viewBox: "0 0 233.088 33.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6014",
    "data-name": "Group 6014",
    transform: "translate(-77 -58.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6951",
    "data-name": "Path 6951",
    d: "M234.416,567.412v31.5h-6.568V585.677H213.585v13.238h-6.567v-31.5h6.567v12.519h14.264V567.412Z",
    transform: "translate(-130.018 -506.565)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6952",
    "data-name": "Path 6952",
    d: "M269.773,591.7h8.877c-.051-2.411-1.488-4.31-4.1-4.31-2.463,0-4.207,1.488-4.772,4.31m14.982,6.465c-.821,4.875-4.412,8-10.159,8-6.67,0-11.134-4.875-11.134-11.955,0-6.927,4.618-12.006,11.031-12.006,6.722,0,10.416,4.669,10.416,11.39v1.95H269.62c.205,3.438,2.155,5.49,4.977,5.49,2.154,0,3.745-.923,4.258-2.873Z",
    transform: "translate(-155.73 -513.305)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6953",
    "data-name": "Path 6953",
    d: "M314.258,597.5H307.9V574.563h6.362Zm-3.181-25.911a3.644,3.644,0,1,1,3.745-3.643,3.659,3.659,0,0,1-3.745,3.643",
    transform: "translate(-175.69 -505.148)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6954",
    "data-name": "Path 6954",
    d: "M353.632,582.207c4.721,0,7.542,3.284,7.542,8.466v14.982h-6.362V592.007c0-2.463-1.078-4.1-3.284-4.1a3.543,3.543,0,0,0-3.54,2.976v14.777h-6.413V592.007c0-2.463-1.026-4.1-3.233-4.1a3.6,3.6,0,0,0-3.591,2.976v14.777h-6.362V582.72h6.362v1.9a7.294,7.294,0,0,1,5.8-2.411,7.6,7.6,0,0,1,6.157,2.924,8.939,8.939,0,0,1,6.927-2.924",
    transform: "translate(-185.305 -513.305)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6955",
    "data-name": "Path 6955",
    d: "M400,598.831a3.7,3.7,0,0,0,3.848,2.514c1.949,0,3.232-.769,3.232-2.257,0-1.026-.718-1.539-2.309-1.95l-4.618-1.026c-3.489-.821-5.952-2.617-5.952-6.465,0-4.464,4-7.44,9.133-7.44,5.8,0,8.979,2.771,9.749,7.08H407.03c-.411-1.282-1.488-2.257-3.591-2.257-1.539,0-3.027.718-3.027,2.155,0,.923.616,1.436,2.052,1.8l4.721,1.078c4,.975,6.106,3.181,6.106,6.67,0,4.669-4.054,7.44-9.39,7.44-5.593,0-9.544-2.668-10.211-7.337Z",
    transform: "translate(-215.05 -513.305)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M435.343,583.085h-3.489v-5.131h3.489v-6.209h6.311v6.209h5.028v5.131h-5.028v10.056a2.333,2.333,0,0,0,2.617,2.617,5.452,5.452,0,0,0,2.77-.77v5.644a9.656,9.656,0,0,1-4.1.718c-4.669,0-7.594-2.309-7.594-7.388Z",
    transform: "translate(-232.435 -508.54)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M477.25,597.753c-.565-1.232-2.309-2-4.156-2-2,0-4.054.872-4.054,2.822,0,2,2.053,2.822,4.054,2.822,1.847,0,3.591-.77,4.156-2Zm0,7.9v-1.232c-.77.77-3.078,1.642-5.593,1.642-4.618,0-8.517-2.668-8.517-7.44,0-4.361,3.9-7.337,8.876-7.337a10.674,10.674,0,0,1,5.234,1.334V590.93c0-1.95-1.18-3.54-3.745-3.54a3.29,3.29,0,0,0-3.387,2.154h-6.054c.667-4.156,4.412-7.337,9.646-7.337,6.106,0,9.646,3.335,9.646,8.825v14.623Z",
    transform: "translate(-246.686 -513.305)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M521.422,582.131a4.855,4.855,0,0,0-4.31-2.668c-3.437,0-5.49,2.771-5.49,6.465,0,3.643,2.053,6.414,5.49,6.414a4.708,4.708,0,0,0,4.31-2.668Zm0,13.34a7.9,7.9,0,0,1-5.746,2.411c-6.67,0-10.416-5.388-10.416-11.955s3.745-12.006,10.416-12.006a7.9,7.9,0,0,1,5.746,2.411V564.019h6.413V597.37h-6.413Z",
    transform: "translate(-265.874 -505.02)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6959",
    "data-name": "Path 6959",
    d: "M558.593,591.7h8.876c-.051-2.411-1.488-4.31-4.1-4.31-2.463,0-4.207,1.488-4.771,4.31m14.982,6.465c-.821,4.875-4.412,8-10.159,8-6.67,0-11.134-4.875-11.134-11.955,0-6.927,4.618-12.006,11.031-12.006,6.722,0,10.416,4.669,10.416,11.39v1.95h-15.29c.205,3.438,2.155,5.49,4.977,5.49,2.155,0,3.745-.923,4.258-2.873Z",
    transform: "translate(-287.293 -513.305)",
    fill: "#fe7333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6960",
    "data-name": "Path 6960",
    d: "M597.23,582.72h6.362v2.1a8.219,8.219,0,0,1,6.157-2.617c5.182,0,8.107,3.386,8.107,8.466v14.982h-6.362V592.006c0-2.411-1.231-4.053-3.746-4.053a4.169,4.169,0,0,0-4.156,3.181v14.521H597.23Z",
    transform: "translate(-307.768 -513.305)",
    fill: "#fe7333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeimLogo);
export default __webpack_public_path__ + "static/media/heim-logo.7093c22260d9339a63a779277ed990f9.svg";
export { ForwardRef as ReactComponent };